import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=60944a2f&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60944a2f",
  null
  
)

export default component.exports